import { normalizeClickByDate } from './adsClicks';
import { parseSingaporeDateTime } from './singaporeTime';

const SINGAPORE_TZ = 'Asia/Singapore';
const DEFAULT_DAYS = 30;

function toChartDateKey(value) {
    if (value == null || value === '') return '';

    const str = String(value).trim();
    const dmyMatch = str.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
    if (dmyMatch) {
        const [, d, m, y] = dmyMatch;
        return `${y}-${m}-${d}`;
    }

    const parsed = parseSingaporeDateTime(value) || new Date(str);
    if (!Number.isFinite(parsed?.getTime())) return '';

    return new Intl.DateTimeFormat('en-CA', {
        timeZone: SINGAPORE_TZ,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
    }).format(parsed);
}

function buildLastNDayLabels(daysCount) {
    const labels = [];
    const now = Date.now();
    const fmt = new Intl.DateTimeFormat('en-CA', {
        timeZone: SINGAPORE_TZ,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
    });
    for (let i = daysCount - 1; i >= 0; i -= 1) {
        labels.push(fmt.format(new Date(now - i * 86400000)));
    }
    return labels;
}

/**
 * Build last-N-days total click series for one ad's adsClicks.
 * @returns {{ series: { date: string, clicks: number }[], totalClicks: number }}
 */
export function buildAdsClickAnalytics(adsClicks = [], days = DEFAULT_DAYS) {
    const daysCount = Math.min(Math.max(Number(days) || DEFAULT_DAYS, 1), 90);
    const labels = buildLastNDayLabels(daysCount);
    const labelSet = new Set(labels);
    const byDate = new Map();

    for (const day of normalizeClickByDate(adsClicks)) {
        const key = toChartDateKey(day.date);
        if (!key || !labelSet.has(key)) continue;
        const total = (day.sources || []).reduce((sum, row) => sum + (Number(row?.count) || 0), 0);
        byDate.set(key, (byDate.get(key) || 0) + total);
    }

    const series = labels.map((date) => ({
        date,
        clicks: byDate.get(date) || 0,
    }));

    const totalClicks = series.reduce((sum, row) => sum + row.clicks, 0);

    return { series, totalClicks };
}
